import styled from 'react-emotion';

import UnstyledAddIcon from '@mui/icons-material/Add';

export const AddIcon = styled(UnstyledAddIcon)`
  font-size: 30px;
`;

export const Container = styled('div')`
  margin-left: 8px;
`;
